import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Spinner } from 'components';
import { logout } from 'reduxModules/auth';

export function Logout() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logout());
  }, [dispatch]);

  return <Spinner />;
}

export default Logout;
